export var Purpose;
(function (Purpose) {
    Purpose["NewPurchase"] = "NEW_PURCHASE";
    Purpose["Refinance"] = "REFINANCE";
})(Purpose || (Purpose = {}));
export var PrimaryPurpose;
(function (PrimaryPurpose) {
    PrimaryPurpose["Commercial"] = "COMMERCIAL";
    PrimaryPurpose["Construction"] = "CONSTRUCTION";
    PrimaryPurpose["ConstructionAndPurchase"] = "CONSTRUCTION_AND_PURCHASE";
    PrimaryPurpose["ConstructionAndRefinance"] = "CONSTRUCTION_AND_REFINANCE";
    PrimaryPurpose["FastRefinance"] = "FAST_REFINANCE";
    PrimaryPurpose["InternalRefinance"] = "INTERNAL_REFINANCE";
    PrimaryPurpose["NewPurchase"] = "NEW_PURCHASE";
    PrimaryPurpose["PreApproval"] = "PRE_APPROVAL";
    PrimaryPurpose["Purchase"] = "PURCHASE";
    PrimaryPurpose["PurchaseAndRefinance"] = "PURCHASE_AND_REFINANCE";
    PrimaryPurpose["Refinance"] = "REFINANCE";
    PrimaryPurpose["SLR"] = "SLR";
    PrimaryPurpose["TopUp"] = "TOP_UP";
    PrimaryPurpose["Variation"] = "VARIATION";
    PrimaryPurpose["VariationCreditCritical"] = "VARIATION_CREDIT_CRITICAL";
    PrimaryPurpose["VariationNonCreditCritical"] = "VARIATION_NON_CREDIT_CRITICAL";
})(PrimaryPurpose || (PrimaryPurpose = {}));
//# sourceMappingURL=Purpose.js.map